import React from 'react'

type inputFieldPropType = {
  htmlFor: string
  labelName: string
  name: string
  type: string
  value: string
  handelChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

function InputField({
  htmlFor,
  labelName,
  name,
  type,
  value,
  handelChange,
}: inputFieldPropType) {
  return (
    <label
      htmlFor={htmlFor}
      className="w-full text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 "
    >
      {labelName}
      <input
        type={type}
        className=" mt-1 flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus:border-black focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50"
        name={name}
        value={value}
        onChange={handelChange}
      />
    </label>
  )
}

export default InputField
